<script setup lang="ts">
import {RouterLink, RouterView, useRouter} from 'vue-router'
import AppHeader from './components/layout/app-header.vue'
import AppFooter from './components/layout/app-footer.vue'
import Toast from './components/services/toast.vue'
import { useAuthStore } from '@/stores/auth.ts'

const authStore = useAuthStore()
const path = window.location.pathname
const router = useRouter()


</script>

<template>
  <Toast />

  <AppHeader></AppHeader>

  <main
    class="min-h-[100vh]"
    :class="{ 'pt-[70px]': authStore.isAuthenticated && path.includes('dashboard') && !path.includes('dashboard/exercises') }"
  >
    <RouterView />
  </main>

  <AppFooter></AppFooter>
  <div class="fixed bottom-4 right-4 z-50">
  <a
    title="Discuter avec nous sur whatsapp au +227 77 85 86 84"
    href="https://wa.me/22777858684?text=Bonjour%20LINGUIDIA%2C%20j%27ai%20une%20question"
    target="_blank"
    rel="noopener noreferrer"
    class="flex items-center justify-center w-14 h-14 bg-green-500 rounded-full shadow-lg hover:bg-green-600 transition-colors duration-300 transform hover:scale-110"
    aria-label="Contacter-nous sur WhatsApp"
  >
    <i class="fa-brands fa-whatsapp text-[35px] text-white"></i>
  </a>
</div>
</template>

<style scoped>
header {
  line-height: 1.5;
  max-height: 100vh;
}

.logo {
  display: block;
  margin: 0 auto 2rem;
}

nav {
  width: 100%;
  font-size: 12px;
  text-align: center;
  margin-top: 2rem;
}

nav a.router-link-exact-active {
  color: var(--color-text);
}

nav a.router-link-exact-active:hover {
  background-color: transparent;
}

nav a {
  display: inline-block;
  padding: 0 1rem;
  border-left: 1px solid var(--color-border);
}

nav a:first-of-type {
  border: 0;
}

@media (min-width: 1024px) {
  header {
    display: flex;
    place-items: center;
    padding-right: calc(var(--section-gap) / 2);
  }

  .logo {
    margin: 0 2rem 0 0;
  }

  header .wrapper {
    display: flex;
    place-items: flex-start;
    flex-wrap: wrap;
  }

  nav {
    text-align: left;
    margin-left: -1rem;
    font-size: 1rem;

    padding: 1rem 0;
    margin-top: 1rem;
  }
}
</style>
